import { Virtuoso } from 'react-virtuoso';
import EDGrid from './EDGrid';

interface IProps {
  useVirtual: boolean;
  totalCount: number;
  item: (index: number) => React.ReactElement<any>;
  setIsScrolling: (isScrolling: boolean) => void;
}

const style = { height: '100%', width: '100%' };

export const EDVirtualGrid: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return props.useVirtual && !!props.item && props.totalCount ? (
    <Virtuoso
      totalCount={props.totalCount}
      itemContent={props.item}
      style={style}
      isScrolling={props.setIsScrolling}
    />
  ) : (
    <EDGrid container alignItems="stretch" spacing={0}>
      {props.children}
    </EDGrid>
  );
};

export default EDVirtualGrid;
